<template>
  <div class="preViews">
    <page-none :resultList="detailList" :swiperList="swiperList"/>
    <!-- <page-have :resultList="detailList"/> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// 调用接口
import { postDetail, getSession } from "@/api/company";

import pageNone from './pages'

export default {
  name: "company",
  data() {
    return {
      pageCompanyData: {
        organCode: "JG0325",
        only_meta: 2,
        is_total: 1,
      },
      preViews: {
        organ_code: '',
        page: 1,
        page_size: 5,
        is_total: 1,
        status: 0,
        ord: 3,
        only_meta: 2,
      },
      detailList: {},
      swiperList: []
    };
  },
  components: {
    pageNone
  },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageOrgMeta/getIsLoadIng",
            getData: "pageOrgMeta/getData",
        }),
    },
    //服务端渲染
    asyncData({ store,route }) {
        let params = {
            type:9,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
  mounted() {
    const webNames = this.$router.history.current.params.name;
    this.postDetail(webNames);
      const webName = this.$route.params.name;
      if (!this.getIsLoadIng){
          let parmas = {
              type:9,
              zone_name:webName
          }
          this.setOrgMeta([parmas,()=>{
              this.filteData();
          }])
      }else{
          this.filteData();
      }
  },
  methods: {
      ...mapActions({
          setOrgMeta:"pageOrgMeta/setOrgMeta"
      }),
      filteData(){
          let data = this.$store.state["pageOrgMeta"]["data"]
          console.log(data,'pageOrgMeta')
          document.title = data.meta ? data.meta.title :'';
          let head = document.getElementsByTagName('head');
          this.isLoading = false
          if(!document.querySelector('meta[name=description]')){
              let meta = document.createElement('meta');
              meta.name = 'description';
              meta.content = data.meta ? data.meta.description : '';
              head[0].appendChild(meta)
          }else{
              document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
          }
      },
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.preViews.organ_code = res.data.organ_id;
        this.preViews.special_top = 50
        this.getSession()
      });
    },
    getSession() {
      getSession(this.preViews).then(res => {
        this.detailList = res.data.dataList
        for(let i = 0; i < res.data.dataList.length; i++) {
          this.segmentation(res.data.dataList[i].specialsList)
        }
      })
    },
    segmentation(result) {
      let newResult = []
      for(let i = 0; i < result.length; i += 3) {
        newResult.push(result.slice(i, i + 3))
      }
      this.swiperList.push(newResult)
    }
  },
};
</script>

<style lang="scss" scoped>
</style>